import { useBulletinBoards } from './use-bulletin-boards';

import type { Distributor } from '@autopass-web/types';

interface UseMapCtaButtonImageProps {
  distributor: Distributor;
}

export const useMapCtaButtonImage = ({
  distributor,
}: UseMapCtaButtonImageProps) => {
  const { bulletinBoards } = useBulletinBoards({
    codes: 'map_cta_button',
    distributor,
  });

  const mapCtaButtonInfo = bulletinBoards?.['map_cta_button']?.[0];

  const { map_cta_button_image } = mapCtaButtonInfo?.attributes ?? {};

  return {
    mapCtaButtonImage: map_cta_button_image,
  };
};
